import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from 'src/App';
import reportWebVitals from 'src/reportWebVitals';

import 'src/i18n';
import rootStore from 'src/stores/rootStore';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

// @ts-expect-error
if (window.Cypress) {
  // @ts-expect-error
  window.store = rootStore;
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
